import type { AuthUser } from '@contracts/auth'
import type { AssetScope } from '@/shared/types'
import { PERMISSIONS } from './permissions'

/** The signed-in user as the frontend sees it. Built from the backend's user, never sent by it. */
export interface Session {
  user: {
    id: string
    email: string
    /** Display name; falls back to the e-mail address. */
    name: string
  }
  permissions: readonly string[]
  scopes: readonly AssetScope[]
}

/**
 * The backend has no roles or permissions yet: every signed-in user has the same access
 * (ADR-0009). This is the single place that grants it; replace it when the backend sends them.
 */
export function toSession(user: AuthUser): Session {
  const name = `${user.first_name} ${user.last_name}`.trim()
  return {
    user: { id: user.id, email: user.email, name: name.length > 0 ? name : user.email },
    permissions: PERMISSIONS,
    scopes: [{ level: 'global' }],
  }
}
